import {createActions} from 'redux-actions';
import fetchJson from '../fetchJson';
import handleError from '../handleError';
import ReactGA from 'react-ga';

const actions = createActions(
	'SEARCH_SET_QUERY',
	'HIDDEN_SEARCH_SET_QUERY',
	'SEARCH_CLEAR_RESULTS',
	'SEARCH_START',
	'SEARCH_COMPLETE',
	'SEARCH_TOGGLE_COMMUNITY_FILTER',
	'SEARCH_FILTER_SUBURB',
	'SEARCH_FOR',
	'SEARCH_RECOMMENDATIONS_LOADED',
	'RESET_STATE'
);

export const performSearch = () => dispatch => {
	dispatch(actions.searchClearResults());

	ReactGA.event({
		category: 'Search',
		action: 'Search'
	});

	dispatch(searchMore());
};

export const searchMore = () => (dispatch, getState) => {
	const {search, session} = getState();
	const {searchFor, results, isRetrieving, hiddenQuery} = search;
	let {query} = search;
	query = query || hiddenQuery;

	if (!query) return; // Ignore empty queries

	if (isRetrieving) return; // Prevent multiple concurrent searches and dupe results etc

	dispatch(actions.searchStart());

	fetchJson(
		`/api/search/${encodeURIComponent(query)}?type=${searchFor || 'provider'}&offset=${
			results.length
		}`
	)
		.then(results => {
			const newQuery = getState().search.query || getState().search.hiddenQuery;
			if (newQuery !== query) return; // Search query changed, discard result

			dispatch(actions.searchComplete(results));

			// Get recommendations if logged in and searching for provider
			if (
				session &&
				session.current &&
				session.current.user &&
				(!searchFor || searchFor === 'provider')
			) {
				return fetchJson(
					`/api/providers/recommendations?providers=${encodeURIComponent(
						JSON.stringify(results.map(provider => provider.uuid))
					)}`
				);
			}
		})
		.then(results => {
			if (results) {
				dispatch(actions.searchRecommendationsLoaded(results));
			}
		})
		.catch(handleError(dispatch));
};

export default {...actions, performSearch, searchMore};



// WEBPACK FOOTER //
// ./src/search/search.actions.js